import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { Icon, Typography } from '@/components';

// ─── Component ───────────────────────────────────────────────────────────────

export function BuyerPendingCard() {
  const { t } = useTranslation(['offers']);

  return (
    <Card className="mb-6 overflow-hidden border border-amber-200 bg-amber-50">
      {/* Header */}
      <div className="px-5">
        <div className="flex flex-col items-center text-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-600">
            <Icon name="clock" className="h-6 w-6 text-white" />
          </div>
          <Typography as="h3" size="body-1" className="font-bold text-amber-900">
            {t('Under review')}
          </Typography>
          <Typography size="body-3" className="mt-1 text-amber-700">
            {t(
              "Your Expression of Interest is being reviewed by the seller. You'll be notified once a decision is made."
            )}
          </Typography>
        </div>
      </div>

      {/* What happens next */}
      <CardContent className="pt-4 pb-5">
        <div className="rounded-lg border border-amber-200 bg-white px-4 py-3">
          <Typography size="body-3" className="mb-3 font-bold tracking-wide text-slate-500 uppercase">
            {t('What happens next')}
          </Typography>

          <div className="flex flex-col gap-3">
            <div className="flex items-start gap-1.5">
              <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" />
              <Typography size="body-3" className="text-slate-500">
                {t('If accepted, the seller will propose time slots for a Kick-off Meeting.')}
              </Typography>
            </div>
            <div className="flex items-start gap-1.5">
              <Icon name="x" className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" />
              <Typography size="body-3" className="text-slate-500">
                {t("If declined, you'll receive feedback from the seller.")}
              </Typography>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
